"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import { onKeyDownInputHandlers } from "./shared/formUtils";
const HIDE_DEFAULT_INPUT_STYLES = {
    opacity: 0,
    position: "absolute",
    zIndex: -1
};
const CHECKED_CLASS = "w--redirected-checked";
const FOCUSED_CLASS = "w--redirected-focus";
const FOCUSED_VISIBLE_CLASS = "w--redirected-focus-visible";
const FormBooleanInput = /*#__PURE__*/ React.forwardRef(function FormBooleanInput(_param, ref) {
    var { className = "", checked = false, type = "checkbox", inputType, customClassName, form: _form } = _param, props = _object_without_properties(_param, [
        "className",
        "checked",
        "type",
        "inputType",
        "customClassName",
        "form"
    ]);
    const [isChecked, setIsChecked] = React.useState(checked);
    const [isFocused, setIsFocused] = React.useState(false);
    const [isFocusedVisible, setIsFocusedVisible] = React.useState(false);
    const wasClicked = React.useRef(false);
    const inputProps = {
        checked: isChecked,
        type,
        onChange: (e)=>{
            if (props.onChange) props.onChange(e);
            setIsChecked((prevIsChecked)=>!prevIsChecked);
        },
        onClick: (e)=>{
            if (props.onClick) props.onClick(e);
            wasClicked.current = true;
        },
        onFocus: (e)=>{
            if (props.onFocus) props.onFocus(e);
            setIsFocused(true);
            if (!wasClicked.current) {
                setIsFocusedVisible(true);
            }
        },
        onBlur: (e)=>{
            if (props.onBlur) props.onBlur(e);
            setIsFocused(false);
            setIsFocusedVisible(false);
            wasClicked.current = false;
        },
        onKeyDown: onKeyDownInputHandlers
    };
    if (inputType === "custom") {
        const pseudoModeClasses = `${isChecked ? ` ${CHECKED_CLASS}` : ""}${isFocused ? ` ${FOCUSED_CLASS}` : ""}${isFocusedVisible ? ` ${FOCUSED_CLASS} ${FOCUSED_VISIBLE_CLASS}` : ""} ${customClassName !== null && customClassName !== void 0 ? customClassName : ""}`;
        const currentClassName = `${className}${pseudoModeClasses}`;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: currentClassName
        }), /*#__PURE__*/ React.createElement("input", _object_spread_props(_object_spread({
            ref: ref
        }, props, inputProps), {
            style: HIDE_DEFAULT_INPUT_STYLES
        })));
    }
    return /*#__PURE__*/ React.createElement("input", _object_spread({
        ref: ref,
        className: className
    }, props, inputProps));
});
export default FormBooleanInput;
